<template>
  <div class="upload-file-box">
    <el-upload
      action
      name="upload"
      :disabled="disabled"
      :before-upload="handleBeforeUpload"
      :show-file-list="false"
      :size="size || $xUISize"
    >
      <el-button
        type="primary"
        :disabled="disabled"
        :loading="loading"
        :size="size || $xUISize"
      >
        {{ btnLabel }}
      </el-button>
    </el-upload>
    <el-link
      v-if="!!fileTplUrl"
      type="primary"
      :size="size || $xUISize"
      @click="downloadClick"
    >
      下载文件模板
    </el-link>
  </div>
</template>

<style lang="less" scoped>
/deep/ .el-button.is-loading:before {
  background-color: transparent;
}

.upload-file-box {
  display: flex;
  gap: 10px;
}
</style>

<script>
/**
 * 根据URL地址获取文件名，若地址为空则生成随机名称，且在文件名末尾添加时间戳
 * @param {string} url - 文件的URL地址
 * @returns {string} 带时间戳的文件名
 */
function getFileNameWithTime(url) {
  // 生成时间戳（精确到秒，避免文件名过长）
  const timeStr = new Date().getTime().toString().slice(0, 10);

  // 处理URL为空的情况
  if (!url || typeof url !== "string" || url.trim() === "") {
    const randomStr = Math.random().toString(36).substring(2, 8);
    return `file_${randomStr}_${timeStr}`;
  }

  // 提取原始文件名
  let originalName;
  try {
    const urlObj = new URL(url);
    originalName = urlObj.pathname.split("/").pop();
  } catch (e) {
    // 处理相对路径或不规范URL
    originalName = url.split(/[\\/]/).pop();
  }

  // 如果提取失败，使用随机名作为基础
  if (!originalName) {
    const randomStr = Math.random().toString(36).substring(2, 8);
    originalName = `file_${randomStr}`;
  }

  // 分离文件名和扩展名
  const dotIndex = originalName.lastIndexOf(".");
  let namePart = originalName;
  let extPart = "";

  if (dotIndex > 0) {
    // 确保扩展名存在（避免以.开头的文件）
    namePart = originalName.substring(0, dotIndex);
    extPart = originalName.substring(dotIndex);
  }

  // 拼接带时间戳的文件名
  return `${namePart}_${timeStr}${extPart}`;
}

export default {
  data() {
    return {
      fileReader: new FileReader(),
    };
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    types: {
      type: Array,
      default: () => {
        return [];
      },
    },
    fileSize: {
      type: Number | String,
      default: 1024,
    },
    fileTplUrl: {
      type: String,
    },
    size: {
      type: String,
      default: "small",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    btnLabel: {
      type: String,
      default: "上传文件",
    },
  },
  methods: {
    onChange() {
      this.$emit("change", this.url);
    },
    sizeConver(limit) {
      var size = "";
      if (limit < 1 * 1024) {
        size = limit.toFixed(2) + "B";
      } else if (limit < 1 * 1024 * 1024) {
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 1 * 1024 * 1024 * 1024) {
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }
      var sizestr = size + "";
      var len = sizestr.indexOf(".");
      var dec = sizestr.substr(len + 1, 2);
      if (dec == "00") {
        return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
      }
      return sizestr;
    },
    checkFileSize(e) {
      return e.size / 1024 / 1024 < this.fileSize / 1024;
    },
    checkFileType(e) {
      if (this.types && this.types.length > 0) {
        try {
          return this.types.indexOf(e.type) >= 0;
        } catch (error) {}
        return false;
      }
      return true;
    },
    handleBeforeUpload(e, l) {
      if (!this.checkFileType(e)) {
        this.error("文件格式错误");
        return false;
      }
      if (!this.checkFileSize(e)) {
        this.error(`文件大小不能超过${this.sizeConver(this.fileSize * 1024)}`);
        return false;
      }
      this.fileReader.readAsDataURL(e);
      this.fileReader.onload = () => {
        let base64Str = this.fileReader.result;
        this.$emit("handleUploadFile", { data: base64Str.split(",")[1] });
      };
      return false;
    },
    downloadClick() {
      return fetch(this.fileTplUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`请求 ${this.fileTplUrl} 失败，状态码: ${response.status}`);
          }
          return response.blob();
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = getFileNameWithTime(this.fileTplUrl);
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          }, 100);
        });
    },
  },
};
</script>
